import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function CheckoutCancel() {
  return (
    <div className="pt-40 pb-24 min-h-screen flex items-center justify-center px-6" data-testid="checkout-cancel-page">
      <div className="max-w-xl w-full text-center border border-white/10 bg-[#101010] p-12">
        <XCircle size={56} className="text-white/50 mx-auto mb-6" />
        <h1 className="font-display text-4xl text-white mb-4">Checkout cancelled.</h1>
        <p className="text-white/70">Your items are still in the cart. No charges have been made.</p>
        <Link to="/shop" className="btn-gold inline-flex mt-10" data-testid="resume-shopping-btn">Resume Shopping</Link>
      </div>
    </div>
  );
}
